import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import useLeaseCompsWithFocusArea from "../../hooks/useLeaseCompsWithFocusArea";
import useLeaseCompsWithGlobalFilters from "../../hooks/useLeaseCompsWithGlobalFilters";
import useLocationsWithFocusArea from "../../hooks/useLocationsWithFocusArea";
import useLocationsWithGlobalFilters from "../../hooks/useLocationsWithGlobalFilters";
import useSaleCompsWithFocusArea from "../../hooks/useSaleCompsWithFocusArea";
import useSaleCompsWithGlobalFilters from "../../hooks/useSaleCompsWithGlobalFilters";
import { useLeaseCompStore, useLocationStore, useSaleCompStore } from "../../index";
import infoStyles from "../Info.module.css";

function CompanyInfo({ id, name, className, controls, onClick }: ICompanyInfoProps) {
    const locationStore = useLocationStore();
    const saleCompStore = useSaleCompStore();
    const leaseCompStore = useLeaseCompStore();
    const locations = useLocationsWithFocusArea(useLocationsWithGlobalFilters(
        useMemo(() => computed(() => locationStore.locations.filter(l => l.pipedriveCompanyId === id)), [id, locationStore.locations]).get()
    ));
    const saleComps = useSaleCompsWithFocusArea(useSaleCompsWithGlobalFilters(
        useMemo(() => computed(() => saleCompStore.saleComps.filter(sc => sc.pipedriveBrokerageId === id || sc.pipedriveSellerId === id || sc.pipedriveBuyerId === id)), [id]).get()
    ));
    const leaseComps = useLeaseCompsWithFocusArea(useLeaseCompsWithGlobalFilters(
        useMemo(() => computed(() => leaseCompStore.leaseComps.filter(lc => lc.pipedriveCompanyId && lc.pipedriveCompanyId === id)), [id]).get()
    ));

    return (
        <div className={[infoStyles.flexContainer, className].join(" ")} onClick={onClick}>
            <div>
                <div className={infoStyles.title}>{name}</div>
                <div className={infoStyles.description}>
                    {[
                        `${locations.length} Locations`,
                        `${saleComps.length} Sale Comps`,
                        `${leaseComps.length} Lease Comps`,
                    ].filter(d => d).join(", ")}
                </div>
            </div>
            <div>
                {controls}
            </div>
        </div>
    );
}

export interface ICompanyInfoProps {
    id: number;
    name: string;
    className?: string;
    controls?: React.ReactNode[];
    onClick?: () => void;
}

export default observer(CompanyInfo)
